<template>
  <Head :title="t('page.title')" />
  <s-page-block>
    <s-page-header
      :heading="t('header.heading')"
      :description="t('header.description')"
      class="mb-3"
    ></s-page-header>
    <form
      class="flex flex-col gap-4"
      @submit.prevent="form.post(route('institutions.staff.store', {institution: institution.id}))"
    >
      <s-input-field
        id="email"
        :label="t('email')"
        v-model="form.email"
        :error="form.errors.email"
      />

      <s-searchable-select-field
        id="role"
        :label="t('role')"
        :options="
          roles.map((role: Role) => ({
            value: role.id,
            label: role.name,
          }))
        "
        v-model="form.roleId"
        :error="form.errors.roleId"
      />

      <s-btn-group>
        <s-btn icon="plus">{{ t('actions.add') }}</s-btn>
        <s-btn
          icon="close"
          color="secondary"
          :href="route('institutions.staff.index', {institution: institution.id})"
        >
          {{ t('actions.cancel') }}
        </s-btn>
      </s-btn-group>
    </form>
  </s-page-block>
</template>
<script setup lang="ts">
import {Head, useForm} from '@inertiajs/vue3';
import {route} from 'ziggy-js';
import {useI18n} from 'vue-i18n';
import SPageBlock from '../../design-system/SPageBlock.vue';
import SPageHeader from '../../design-system/SPageHeader.vue';
import {Institution} from '../../types/entities/institution.js';
import SInputField from '../../design-system/SInputField.vue';
import SBtnGroup from '../../design-system/SBtnGroup.vue';
import SBtn from '../../design-system/SBtn.vue';
import SSearchableSelect from '../../design-system/Examples/SSearchableSelect.vue';
import SSearchableSelectField from '../../design-system/SSearchableSelectField.vue';
import {Role} from '../../types/entities/role.js';

defineProps<{
  institution: Institution;
  roles: Role[];
}>();

const {t} = useI18n({
  useScope: 'local',
  inheritLocale: true,
});

const form = useForm({
  email: '',
  roleId: null,
});
</script>
<i18n>
{
  "en": {
    "page.title": "Add Staff Member - {institutionName}",
    "header.heading": "Add Staff Member",
    "header.description": "Make an existing Stemble user a member of this institution."
  },
  "fr": {
    "page.title": "Ajouter un membre du personnel - {institutionName}",
    "header.heading": "Ajouter un membre du personnel",
    "header.description": "Faire d'un utilisateur existant de Stemble un membre de cette institution."
  }
}
</i18n>
